var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1677,
    height: 896,
    viewBox: "0 0 1677 896",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_863)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1677,
    height: 896,
    fill: "#6400E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.912 238C842.913 238 875.297 275.543 887.681 328.168C908.918 287.787 947.921 260.723 992.522 260.723C1042.94 260.723 1086.2 295.3 1104.74 344.603C1121.69 347.109 1138.33 353.233 1154.13 362.818C1175.36 375.701 1194.66 394.583 1210.91 418.386C1214.7 423.937 1218.3 429.732 1221.72 435.747C1229.39 428.907 1237.42 422.927 1245.75 417.871C1266.99 404.989 1289.74 398.358 1312.73 398.358C1335.43 398.358 1357.91 404.828 1378.92 417.402C1395.03 394.062 1414.08 375.523 1435.02 362.818C1456.25 349.936 1479.01 343.306 1501.99 343.306C1524.98 343.306 1547.73 349.936 1568.97 362.818C1590.2 375.701 1609.49 394.583 1625.74 418.386C1641.99 442.189 1654.89 470.447 1663.68 501.548C1671.12 527.868 1675.51 555.788 1676.68 584.153H1677V599.193C1677 599.344 1677 599.494 1677 599.645H1677V897.265H604.744C604.37 897.268 603.996 897.269 603.621 897.269C603.246 897.269 602.871 897.268 602.497 897.265H165.934V897.047C73.6049 891.97 0 796.957 0 680.491C0.000125564 560.773 77.7731 463.722 173.711 463.722C201.867 463.722 228.459 472.082 251.979 486.92C256.34 415.383 309.099 358.88 373.544 358.88C398.741 358.88 422.151 367.519 441.581 382.315C448.616 313.86 500.123 260.723 562.619 260.723C613.028 260.723 656.287 295.295 674.826 344.591C689.358 346.74 703.663 351.547 717.404 358.914C722.688 290.787 759.852 238 804.912 238Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085.79 398.916C1130.26 398.916 1168.42 425.797 1184.77 464.125C1192.95 465.192 1201.05 467.1 1208.99 469.83C1223.25 447.174 1244.31 432.842 1267.79 432.842C1302.88 432.842 1332.54 464.827 1342.22 508.764C1350.79 506.873 1359.49 505.914 1368.23 505.914C1388.5 505.914 1408.57 511.068 1427.3 521.083C1446.03 531.097 1463.04 545.776 1477.38 564.281C1477.97 565.047 1478.56 565.822 1479.14 566.6C1493.01 559.625 1507.39 556.066 1521.87 556.066C1542.24 556.066 1562.41 563.111 1581.23 576.798C1600.05 590.486 1617.15 610.548 1631.56 635.839C1645.96 661.131 1657.39 691.157 1665.19 724.202C1672.44 754.948 1676.42 787.748 1676.93 820.973H1677V895.593H1310.41V895.594H448.659V894.086C445.906 894.279 443.13 894.393 440.333 894.418C365.45 895.1 304.043 834.584 303.177 759.251C302.48 698.58 341.266 646.802 395.508 628.59C392.723 617.575 391.209 605.741 391.208 593.419C391.208 534.328 426.021 486.424 468.963 486.424C489.214 486.424 507.655 497.079 521.492 514.535C534.237 469.604 575.727 436.677 624.942 436.677C663.53 436.677 697.368 456.92 716.326 487.32C721.079 483.983 725.972 480.963 730.99 478.28C749.718 468.265 769.791 463.111 790.063 463.111C810.334 463.111 830.408 468.265 849.136 478.28C867.865 488.294 884.881 502.973 899.215 521.478C902.558 525.793 905.737 530.299 908.749 534.975C915.514 529.659 922.599 525.008 929.95 521.078C945.372 512.831 961.706 507.883 978.312 506.392C978.311 506.232 978.31 506.071 978.31 505.911C978.31 446.82 1026.43 398.917 1085.79 398.916Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 850.515,
    cy: 786.837,
    rx: 133.755,
    ry: 110.004,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 844.527,
    y: 737.946,
    width: 832.474,
    height: 158.894,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1407.49 745.803C1407.49 728.721 1410.98 711.805 1417.75 696.022C1424.52 680.24 1434.45 665.9 1446.96 653.82C1459.47 641.741 1474.33 632.159 1490.68 625.622C1507.03 619.084 1524.55 615.72 1542.25 615.72C1559.94 615.72 1577.46 619.084 1593.81 625.622C1610.16 632.159 1625.02 641.741 1637.53 653.82C1650.04 665.9 1659.97 680.24 1666.74 696.023C1673.51 711.805 1677 728.721 1677 745.803L1542.25 745.803L1407.49 745.803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.76 773.741C1261.76 756.658 1265.25 739.742 1272.02 723.96C1278.79 708.178 1288.72 693.837 1301.23 681.758C1313.74 669.678 1328.6 660.097 1344.95 653.559C1361.3 647.022 1378.82 643.657 1396.51 643.657C1414.21 643.657 1431.73 647.022 1448.08 653.559C1464.43 660.097 1479.29 669.678 1491.8 681.758C1504.31 693.837 1514.24 708.178 1521.01 723.96C1527.78 739.743 1531.27 756.658 1531.27 773.741L1396.51 773.741L1261.76 773.741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.373 806.917C928.373 789.834 931.859 772.918 938.631 757.136C945.402 741.353 955.328 727.013 967.841 714.933C980.354 702.854 995.209 693.272 1011.56 686.735C1027.91 680.198 1045.43 676.833 1063.13 676.833C1080.82 676.833 1098.34 680.198 1114.69 686.735C1131.04 693.272 1145.9 702.854 1158.41 714.934C1170.92 727.013 1180.85 741.353 1187.62 757.136C1194.39 772.918 1197.88 789.834 1197.88 806.917L1063.13 806.917L928.373 806.917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.08 745.803C1088.08 728.721 1091.57 711.805 1098.34 696.022C1105.11 680.24 1115.04 665.9 1127.55 653.82C1140.06 641.741 1154.92 632.159 1171.27 625.622C1187.62 619.084 1205.14 615.72 1222.84 615.72C1240.53 615.72 1258.05 619.084 1274.4 625.622C1290.75 632.159 1305.61 641.741 1318.12 653.82C1330.63 665.9 1340.56 680.24 1347.33 696.023C1354.1 711.805 1357.59 728.721 1357.59 745.803L1222.83 745.803L1088.08 745.803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1149.97,
    cy: 643.657,
    rx: 93.828,
    ry: 69.8436,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 519.491,
    cy: 786.834,
    rx: 133.755,
    ry: 110.004,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 513.504,
    y: 737.944,
    width: 832.474,
    height: 158.894,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.47 745.801C1076.47 728.718 1079.96 711.803 1086.73 696.02C1093.5 680.238 1103.43 665.898 1115.94 653.818C1128.45 641.739 1143.31 632.157 1159.66 625.62C1176 619.082 1193.53 615.718 1211.22 615.718C1228.92 615.718 1246.44 619.082 1262.79 625.62C1279.14 632.157 1294 641.739 1306.51 653.818C1319.02 665.898 1328.95 680.238 1335.72 696.021C1342.49 711.803 1345.98 728.719 1345.98 745.801L1211.22 745.801L1076.47 745.801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.74 773.739C930.74 756.656 934.226 739.74 940.998 723.958C947.77 708.175 957.696 693.835 970.208 681.756C982.721 669.676 997.577 660.094 1013.93 653.557C1030.27 647.02 1047.8 643.655 1065.49 643.655C1083.19 643.655 1100.71 647.02 1117.06 653.557C1133.41 660.094 1148.26 669.676 1160.78 681.756C1173.29 693.835 1183.22 708.175 1189.99 723.958C1196.76 739.74 1200.25 756.656 1200.25 773.739L1065.49 773.739L930.74 773.739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.35 806.915C597.35 789.832 600.835 772.916 607.607 757.134C614.379 741.351 624.305 727.011 636.818 714.931C649.331 702.852 664.186 693.27 680.535 686.733C696.884 680.195 714.407 676.831 732.103 676.831C749.799 676.831 767.321 680.196 783.67 686.733C800.019 693.27 814.874 702.852 827.387 714.931C839.9 727.011 849.826 741.351 856.598 757.134C863.37 772.916 866.855 789.832 866.855 806.915L732.103 806.915L597.35 806.915Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.059 745.801C757.059 728.718 760.544 711.803 767.316 696.02C774.088 680.238 784.014 665.898 796.527 653.818C809.04 641.739 823.895 632.157 840.244 625.62C856.593 619.082 874.116 615.718 891.812 615.718C909.508 615.718 927.03 619.082 943.379 625.62C959.728 632.157 974.583 641.739 987.096 653.818C999.609 665.898 1009.54 680.238 1016.31 696.021C1023.08 711.803 1026.56 728.719 1026.56 745.801L891.812 745.801L757.059 745.801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 818.945,
    cy: 643.655,
    rx: 93.828,
    ry: 69.8436,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1004.6,
    cy: 606.987,
    rx: 67.8755,
    ry: 69.8436,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.375,
    y: 425.536,
    width: 51.9788,
    height: 336.104,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 850.515,
    cy: 786.837,
    rx: 133.755,
    ry: 110.004,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 844.527,
    y: 737.946,
    width: 832.474,
    height: 158.894,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1407.49 745.806C1407.49 728.723 1410.98 711.807 1417.75 696.025C1424.52 680.242 1434.45 665.902 1446.96 653.822C1459.47 641.743 1474.33 632.161 1490.68 625.624C1507.03 619.087 1524.55 615.722 1542.25 615.722C1559.94 615.722 1577.46 619.087 1593.81 625.624C1610.16 632.161 1625.02 641.743 1637.53 653.823C1650.04 665.902 1659.97 680.242 1666.74 696.025C1673.51 711.807 1677 728.723 1677 745.806L1542.25 745.806L1407.49 745.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.76 773.743C1261.76 756.66 1265.25 739.744 1272.02 723.962C1278.79 708.179 1288.72 693.839 1301.23 681.76C1313.74 669.68 1328.6 660.098 1344.95 653.561C1361.3 647.024 1378.82 643.659 1396.51 643.659C1414.21 643.659 1431.73 647.024 1448.08 653.561C1464.43 660.099 1479.29 669.68 1491.8 681.76C1504.31 693.839 1514.24 708.18 1521.01 723.962C1527.78 739.745 1531.27 756.66 1531.27 773.743L1396.51 773.743L1261.76 773.743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.373 806.917C928.373 789.835 931.859 772.919 938.631 757.137C945.402 741.354 955.328 727.014 967.841 714.934C980.354 702.855 995.209 693.273 1011.56 686.736C1027.91 680.198 1045.43 676.834 1063.13 676.834C1080.82 676.834 1098.34 680.198 1114.69 686.736C1131.04 693.273 1145.9 702.855 1158.41 714.934C1170.92 727.014 1180.85 741.354 1187.62 757.137C1194.39 772.919 1197.88 789.835 1197.88 806.918L1063.13 806.917L928.373 806.917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.08 745.806C1088.08 728.723 1091.57 711.807 1098.34 696.025C1105.11 680.242 1115.04 665.902 1127.55 653.822C1140.06 641.743 1154.92 632.161 1171.27 625.624C1187.62 619.087 1205.14 615.722 1222.84 615.722C1240.53 615.722 1258.05 619.087 1274.4 625.624C1290.75 632.161 1305.61 641.743 1318.12 653.823C1330.63 665.902 1340.56 680.242 1347.33 696.025C1354.1 711.807 1357.59 728.723 1357.59 745.806L1222.83 745.806L1088.08 745.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1149.97,
    cy: 643.657,
    rx: 93.828,
    ry: 69.8436,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 519.491,
    cy: 786.833,
    rx: 133.755,
    ry: 110.004,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 513.504,
    y: 737.946,
    width: 832.474,
    height: 158.894,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.47 745.801C1076.47 728.718 1079.96 711.802 1086.73 696.02C1093.5 680.237 1103.43 665.897 1115.94 653.818C1128.45 641.738 1143.31 632.156 1159.66 625.619C1176 619.082 1193.53 615.717 1211.22 615.717C1228.92 615.717 1246.44 619.082 1262.79 625.619C1279.14 632.156 1294 641.738 1306.51 653.818C1319.02 665.897 1328.95 680.237 1335.72 696.02C1342.49 711.802 1345.98 728.718 1345.98 745.801L1211.22 745.801L1076.47 745.801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.74 773.738C930.74 756.655 934.226 739.74 940.998 723.957C947.77 708.175 957.696 693.834 970.208 681.755C982.721 669.676 997.577 660.094 1013.93 653.556C1030.27 647.019 1047.8 643.654 1065.49 643.654C1083.19 643.654 1100.71 647.019 1117.06 653.556C1133.41 660.094 1148.26 669.676 1160.78 681.755C1173.29 693.834 1183.22 708.175 1189.99 723.957C1196.76 739.74 1200.25 756.655 1200.25 773.738L1065.49 773.738L930.74 773.738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.35 806.913C597.35 789.83 600.835 772.914 607.607 757.132C614.379 741.349 624.305 727.009 636.818 714.93C649.331 702.85 664.186 693.268 680.535 686.731C696.884 680.194 714.407 676.829 732.103 676.829C749.799 676.829 767.321 680.194 783.67 686.731C800.019 693.268 814.874 702.85 827.387 714.93C839.9 727.009 849.826 741.349 856.598 757.132C863.37 772.914 866.855 789.83 866.855 806.913L732.103 806.913L597.35 806.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.059 745.801C757.059 728.718 760.544 711.802 767.316 696.02C774.088 680.237 784.014 665.897 796.527 653.818C809.04 641.738 823.895 632.156 840.244 625.619C856.593 619.082 874.116 615.717 891.812 615.717C909.508 615.717 927.03 619.082 943.379 625.619C959.728 632.156 974.583 641.738 987.096 653.818C999.609 665.897 1009.54 680.237 1016.31 696.02C1023.08 711.802 1026.56 728.718 1026.56 745.801L891.812 745.801L757.059 745.801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 818.945,
    cy: 643.657,
    rx: 93.828,
    ry: 69.8436,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1004.6,
    cy: 606.986,
    rx: 67.8755,
    ry: 69.8436,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.375,
    y: 425.536,
    width: 51.9788,
    height: 336.104,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.474 382.522C864.671 410.699 842.962 438.134 833.405 448.948C813.298 445.343 811.457 397.749 818.064 350.561C824.671 303.373 846.327 268.041 866.434 271.646C886.541 275.251 900.082 335.334 893.474 382.522Z",
    fill: "#F5606E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M932.527 382.522C961.33 410.699 983.04 438.134 992.597 448.948C1012.7 445.343 1014.54 397.749 1007.94 350.561C1001.33 303.373 979.675 268.041 959.568 271.646C939.461 275.251 925.92 335.334 932.527 382.522Z",
    fill: "#F5606E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.25 385.913C960.907 410.03 979.492 433.513 987.673 442.769C1004.89 439.683 1009.09 394.31 1003.43 353.919C997.778 313.529 975.092 274.608 957.879 277.694C940.665 280.78 930.594 345.522 936.25 385.913Z",
    fill: "#C74B57"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 912.585,
    cy: 459.761,
    rx: 32.7651,
    ry: 77.2388,
    fill: "#F39C0E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 912.585,
    cy: 455.127,
    rx: 32.7651,
    ry: 69.5149,
    fill: "#EAB000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 912.586,
    cy: 450.493,
    rx: 24.5739,
    ry: 58.7015,
    fill: "#F7E056"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 912.586,
    cy: 431.955,
    rx: 24.5739,
    ry: 58.7015,
    fill: "#FEF3B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.585 123C945.76 123 972.654 209.452 972.654 316.097C972.654 347.815 970.275 377.747 966.06 404.149H859.111C854.896 377.747 852.516 347.815 852.516 316.097C852.516 209.453 879.41 123.001 912.585 123Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.584 123C925.82 123 938.056 136.761 947.983 160.074H877.186C887.113 136.761 899.348 123 912.584 123Z",
    fill: "#F5606E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.342 404.149H965.829L962.324 417.366C961.976 418.681 960.785 419.597 959.425 419.597H865.746C864.385 419.597 863.195 418.681 862.846 417.366L859.342 404.149Z",
    fill: "#572227"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 907.125,
    y: 274.388,
    width: 8.19129,
    height: 169.925,
    fill: "#F5606E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 912.585,
    cy: 224.955,
    rx: 35.4956,
    ry: 40.1642,
    fill: "#F5606E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 912.586,
    cy: 224.955,
    rx: 27.3043,
    ry: 30.8955,
    fill: "#2D0462"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_863"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1677,
    height: 896,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.1d05831a7b1422b3183a90b7bd766b69.svg";
export { ForwardRef as ReactComponent };